import axios from 'axios';
import { baseURL } from '../baseURL';

export default async function getCities(country) {
    const { data } = await axios.get(`${baseURL}amantrans/cities`, {
        params: { country } 
    });

    return data;
}

export async function getFilials(cityId) {
    const { data } = await axios.get(`${baseURL}amantrans/filials-by-filter?cityId=${cityId}`);

    return data;
}

export const getTariffByCity = async (cityId) => {
    const { data } = await axios.get(`${baseURL}amantrans/tariffs/price-by-city/${cityId}`);

    return data;
};

export const getCurrencies = async (country) => {
    const { data } = await axios.get(`${baseURL}amantrans/exchange-rate/current/usd`, {
        params: { country } 
    });

    return data;
};
